import { useContext } from "react";
import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";

import RecipeForm from "components/agro/recipes/RecipeForm";
import { createRecipe } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";

const RecipeCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const recipe = {
    name: "",
    companyID: me?.companyID ?? "",
    code: "",
    date: new Date().toISOString().split("T")[0],
    type: "",
    recipeDetails: "",
    inputId: "",
    availableInventoryQuantity: 0,
    inventoryUnit: "",
    inputQuantityToUse: 0,
    applicationUnit: "",
    preparationProcedure: "",
    performedById: "",
    status: "Activo",
  };

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        companyID,
        code,
        date,
        type,
        recipeDetails,
        inputId,
        availableInventoryQuantity,
        inventoryUnit,
        inputQuantityToUse,
        applicationUnit,
        preparationProcedure,
        performedById,
        status
      } = valuesParam;

      await API.graphql({
        query: createRecipe.replaceAll("__typename", ""),
        variables: {
          input: {
            name,
            companyID,
            code,
            date,
            type,
            recipeDetails,
            inputId,
            availableInventoryQuantity: Number(availableInventoryQuantity),
            inventoryUnit,
            inputQuantityToUse: Number(inputQuantityToUse),
            applicationUnit,
            preparationProcedure,
            performedById,
            status
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error(strings.responses.errorCreate);
      console.error(err);
    }
  }

  return (
    <div>
      <RecipeForm onSubmit={onSubmit} initialValues={recipe} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    successAdded: "Receta agregada con éxito",
    responses: {
      errorCreate: "Error al crear receta",
    },
  },
});

export default RecipeCreateForm;
